import gql from 'graphql-tag'

export const GET_CAMPAIGN = gql`
    query Campaign($type: String) {
        privilege_campaign(type: $type)
    }
`
